"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * Finds all instances of your component in the DOM and numbers them from 0,...,X
 *
 * Returns:
 *
 * elementRef:
 * Put it on the component you would like to enumerate
 *
 * elementIndex:
 * Individual index of the component you put the ref on
 * @param elementName name of the element that should be used for comparing the elements in the DOM
 */
var useUniqueElementIndex = function (elementName) {
    var elemName = elementName.toLowerCase();
    var elementRef = react_1.useRef(null);
    /**
     *  Producing an "unique" string to find out an element's own position index in the DOM
     *  eg if an API should be called with an individual id from different components of the same type
     * */
    var elementUuid = react_1.useMemo(function () { return elemName + "-" + Math.random().toString().substr(2); }, []);
    var _a = react_1.useState(), elementIndex = _a[0], setElementIndex = _a[1];
    react_1.useLayoutEffect(function () {
        var _a;
        (_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.setAttribute("data-" + elemName + "unique", elementUuid);
        document.querySelectorAll("*[data-" + elemName + "unique^=\"" + elemName + "-\"]").forEach(function (v, i) {
            var _a;
            if ((_a = v.getAttribute("data-" + elemName + "unique")) === null || _a === void 0 ? void 0 : _a.match(elementUuid)) {
                setElementIndex(i);
            }
        });
    }, []);
    return [elementRef, elementIndex];
};
exports.default = useUniqueElementIndex;
//# sourceMappingURL=useUniqueElementIndex.js.map